import React, { useState } from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { StepIndicator } from '../../components/StepIndicator';
import { UploadIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const STEPS = ['Select Product', 'Background', 'Greetings', 'Store Info', 'Generate', 'Output Format'];
export function AddDealerInfo() {
  const navigate = useNavigate();
  const [dealerName, setDealerName] = useState('Mumbai Central Motors');
  const [phone, setPhone] = useState('+91 98765 43210');
  const [address, setAddress] = useState('123 MG Road, Mumbai - 400001');
  const [offerText, setOfferText] = useState('');
  const [logoUploaded, setLogoUploaded] = useState(false);
  const [qrCodeEnabled, setQrCodeEnabled] = useState(true);
  const canContinue = dealerName && phone && address;
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1329">
      <Sidebar data-id="element-1330" />
      <main className="flex-1" data-id="element-1331">
        <Header data-id="element-1332" />
        <StepIndicator currentStep={4} steps={STEPS} data-id="element-1333" />
        <div className="px-6 py-8" data-id="element-1334">
          <div className="max-w-5xl mx-auto" data-id="element-1335">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1336">
              Step 4: Add Store Info
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-1337">
              Auto-fill store information with brand-approved formatting
            </p>

            <div className="grid grid-cols-3 gap-6" data-id="element-1338">
              <div className="col-span-2 space-y-6" data-id="element-1339">
                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1340">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1341">
                    Auto-Fill Store Details
                  </h3>
                  <div className="space-y-4" data-id="element-1342">
                    <div data-id="element-1343">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1344">
                        Store Name
                      </label>
                      <input type="text" value={dealerName} onChange={e => setDealerName(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-50" readOnly data-id="element-1345" />
                      <p className="text-xs text-gray-500 mt-1" data-id="element-1346">
                        Position, font, size, and color pre-set by brand
                      </p>
                    </div>

                    <div data-id="element-1347">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1348">
                        Phone Number
                      </label>
                      <input type="text" value={phone} onChange={e => setPhone(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-50" readOnly data-id="element-1349" />
                      <p className="text-xs text-gray-500 mt-1" data-id="element-1350">
                        Format and position pre-set by brand
                      </p>
                    </div>

                    <div data-id="element-1351">
                      <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1352">
                        Address
                      </label>
                      <textarea value={address} onChange={e => setAddress(e.target.value)} rows={2} maxLength={100} className="w-full px-4 py-2 border border-gray-300 rounded-md bg-gray-50" readOnly data-id="element-1353" />
                      <p className="text-xs text-gray-500 mt-1" data-id="element-1354">
                        Max 100 characters, position pre-set
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1355">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1356">
                    Offer Text (Optional)
                  </h3>
                  <div data-id="element-1357">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1358">
                      Special Offer or Discount
                    </label>
                    <input type="text" value={offerText} onChange={e => setOfferText(e.target.value)} placeholder="e.g., Get ₹50,000 off + Free accessories" maxLength={50} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1359" />
                    <p className="text-xs text-gray-500 mt-1" data-id="element-1360">
                      {offerText.length}/50 characters • Font, size, color, and
                      position pre-set
                    </p>
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1361">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1362">
                    Additional Elements
                  </h3>
                  <div className="space-y-4" data-id="element-1363">
                    <div data-id="element-1364">
                      <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-1365">
                        Store Logo
                      </label>
                      {!logoUploaded ? <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center" data-id="element-1366">
                          <UploadIcon className="mx-auto text-gray-400 mb-2" size={32} data-id="element-1367" />
                          <p className="text-sm text-gray-600 mb-3" data-id="element-1368">
                            Upload your store logo
                          </p>
                          <label className="inline-block bg-blue-500 text-white px-4 py-2 rounded-md text-sm cursor-pointer hover:bg-blue-600 transition-colors" data-id="element-1369">
                            Choose File
                            <input type="file" accept="image/*" className="hidden" onChange={() => setLogoUploaded(true)} data-id="element-1370" />
                          </label>
                          <p className="text-xs text-gray-500 mt-2" data-id="element-1371">
                            Position auto-set by brand
                          </p>
                        </div> : <div className="border border-gray-200 rounded-lg p-4 flex items-center justify-between bg-gray-50" data-id="element-1372">
                          <div className="flex items-center" data-id="element-1373">
                            <div className="w-12 h-12 bg-gray-200 rounded mr-3" data-id="element-1374"></div>
                            <div data-id="element-1375">
                              <p className="text-sm font-medium text-gray-700" data-id="element-1376">
                                Logo uploaded
                              </p>
                              <p className="text-xs text-gray-500" data-id="element-1377">
                                Position auto-set
                              </p>
                            </div>
                          </div>
                          <button onClick={() => setLogoUploaded(false)} className="text-sm text-red-500 hover:text-red-600" data-id="element-1378">
                            Remove
                          </button>
                        </div>}
                    </div>

                    <div data-id="element-1379">
                      <label className="flex items-center cursor-pointer" data-id="element-1380">
                        <input type="checkbox" checked={qrCodeEnabled} onChange={e => setQrCodeEnabled(e.target.checked)} className="mr-3 w-4 h-4 text-blue-500 rounded focus:ring-2 focus:ring-blue-500" data-id="element-1381" />
                        <span className="text-sm text-gray-700" data-id="element-1382">
                          Include QR Code (auto-positioned)
                        </span>
                      </label>
                      <p className="text-xs text-gray-500 ml-7 mt-1" data-id="element-1383">
                        Links to your store website or contact page
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-6" data-id="element-1384">
                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1385">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1386">Preview</h3>
                  <div className="w-full h-96 bg-gradient-to-br from-blue-100 to-purple-100 rounded-lg flex flex-col items-center justify-center p-6 relative" data-id="element-1387">
                    {logoUploaded && <div className="absolute top-4 left-4 w-8 h-8 bg-gray-300 rounded" data-id="element-1388"></div>}
                    <div className="text-center mb-8" data-id="element-1389">
                      <p className="font-semibold text-gray-800 mb-2" data-id="element-1390">
                        {dealerName}
                      </p>
                      <p className="text-sm text-gray-700" data-id="element-1391">{phone}</p>
                      <p className="text-xs text-gray-600 mt-1" data-id="element-1392">{address}</p>
                    </div>
                    {offerText && <div className="bg-yellow-400 px-4 py-2 rounded-lg" data-id="element-1393">
                        <p className="text-sm font-semibold text-gray-900" data-id="element-1394">
                          {offerText}
                        </p>
                      </div>}
                    {qrCodeEnabled && <div className="absolute bottom-4 right-4 w-12 h-12 bg-gray-300 rounded" data-id="element-1395"></div>}
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-1396">
                  <h4 className="font-medium text-blue-900 mb-2" data-id="element-1397">
                    Brand Guidelines Applied
                  </h4>
                  <ul className="text-sm text-blue-800 space-y-1" data-id="element-1398">
                    <li data-id="element-1399">• All positions locked</li>
                    <li data-id="element-1400">• Font styles pre-set</li>
                    <li data-id="element-1401">• Colors brand-approved</li>
                    <li data-id="element-1402">• Auto-validation enabled</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex justify-between mt-6" data-id="element-1403">
              <button onClick={() => navigate('/dealer/ai-generator/step-3')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1404">
                Back
              </button>
              <button onClick={() => navigate('/dealer/ai-generator/step-5')} disabled={!canContinue} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors" data-id="element-1405">
                Continue to Generate
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>;
}